import { useSearchParams } from 'react-router-dom';

import { isValidBooleanQuery } from '@/utils/query-utils';

import { SearchParams } from '@domain/app';

export const usePinChangedQuery = () => {
    const [searchParams] = useSearchParams();
    const changedPinQuery = searchParams.get(SearchParams.CHANGED_PIN);

    if (changedPinQuery === null || !isValidBooleanQuery(changedPinQuery)) {
        return false;
    }

    return changedPinQuery === 'true';
};
